export default "__VITE_ASSET__e585fc3d__"